import {createSelector} from "reselect"

export const notifications = (state) =>
  state?.notifications?.notifications

export const unreadNotificationCount = createSelector(
  notifications,
  (notifications) => notifications?.filter(a => !a.read).length
)

export const selectedNotificationId = (state) =>
  state?.notifications?.selectedNotificationId

export const selectedNotification = createSelector(
  notifications,
  selectedNotificationId,
  (notifications, selectedNotificationId) => selectedNotificationId ? notifications?.find(a => parseInt(a.notification_id) === parseInt(selectedNotificationId)) : null
)

export const hasUnreadNotifications = createSelector(
  unreadNotificationCount,
  (count) => count > 0
)